const en = {
  role_owner: "Store owner",
  role_admin: "Store administrator",
  role_product_manager: "Product manager",
  role_order_manager: "Order manager",
  role_support: "Customer support",
  role_analyst: "Read-only analyst",
  save: "Save",
  saving: "Saving…",
  saveChanges: "Save changes",
  saved: "Saved",
  cancel: "Cancel",
  close: "Close",
  confirm: "Confirm",
  delete: "Delete",
  deleting: "Deleting…",
  remove: "Remove",
  edit: "Edit",
  add: "Add",
  create: "Create",
  creating: "Creating…",
  back: "Back",
  next: "Next",
  previous: "Previous",
  continue: "Continue",
  search: "Search",
  filter: "Filter",
  clear: "Clear",
  apply: "Apply",
  view: "View",
  viewAll: "View all",
  open: "Open",
  copy: "Copy",
  copied: "Copied",
  upload: "Upload",
  uploading: "Uploading…",
  publish: "Publish",
  publishing: "Publishing…",
  unpublish: "Unpublish",
  preview: "Preview",
  undo: "Undo",
  retry: "Try again",
  yes: "Yes",
  no: "No",
  none: "None",
  optional: "optional",
  required: "Required",
  loading: "Loading…",
  actions: "Actions",
  status: "Status",
  name: "Name",
  email: "Email",
  phone: "Phone",
  date: "Date",
  total: "Total",
  amount: "Amount",
  price: "Price",
  quantity: "Quantity",
  title: "Title",
  description: "Description",
  type: "Type",
  createdAt: "Created",
  updatedAt: "Updated",
  enabled: "Enabled",
  disabled: "Disabled",
  active: "Active",
  inactive: "Inactive",
  draft: "Draft",
  published: "Published",
  archived: "Archived",
  live: "Live",
  pending: "Pending",
  all: "All",
  page: "Page {page} of {pages}",
  showing: "Showing {from}–{to} of {total}",
  noResults: "No results",
  somethingWrong: "Something went wrong. Please try again.",
  notAllowed: "Your role in this store doesn't allow this action.",
  learnMore: "Learn more",
  unsavedChanges: "You have unsaved changes.",
  areYouSure: "Are you sure?",
  cannotUndo: "This can't be undone.",
  testMode: "Test mode",
  language: "Language",
};

export default en;
